// extracted by mini-css-extract-plugin
export default {"Button":"snslogin_Button__vPdqC","snswrap":"snslogin_snswrap__0NBkN","google":"snslogin_google__OePrU","naver":"snslogin_naver__AoIE7","kakao":"snslogin_kakao__ajNh9"};